// self-service toggle for the AWS-console-style favorites bar under the
// horizon top nav (fi_favorites_bar.vue), on/off -- the left rail's own
// Favorites section shows exactly while this is off (fi_section_nav.vue's
// favoriteSection gate), so the two are mutually exclusive, not both-at-once.
// three entry points write through this: the "Use Toolbar" checkbox on the
// site map's Favorites section, the same checkbox in the left rail's own
// Favorites section, and the bar's own leading star (click to hide it). all
// three need the identical commit + persist, so it lives here once rather
// than duplicated per component.
import store from '@/store'
import { update_nav_favorites_bar } from '@/networking/apis'

export function setNavFavoritesBarEnabled(value) {
  const enabled = !!value
  store.commit('profile/set_nav_favorites_bar', enabled)
  // favorites are a convenience; a failed write just retries on the next
  // toggle, same philosophy as nav_favorites.js's persist()
  update_nav_favorites_bar(enabled).catch(() => {})
}
